import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
    details_container: {
        width: '96%',
    },
    header_container: {
        textAlign: 'center',
        width: '100%'
    },
    name_icon_container: {
        margin: '0 auto',
        paddingBottom: '10px',
        width: '72px'
    },
    hide_small: {
        "@media (max-width: 800px)": {
            display: 'none'
        }
    },
    row_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '97%',
        padding: '5px 0',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        color: theme.palette.grey[800],
        "& > span": {
            marginTop: '10px',
            fontSize: 18,
            color: theme.palette.secondary.light
        },
        "& > div": {
            width: '100%'
        },
    },
    row_container_right: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        "& > div": {
            marginTop: '7px',
            marginLeft: '5px',
        },
    },
    difficult_person_indicator_container: {
        padding: '18px 32px',
        position: 'absolute',
        right: '14px'
    },
    display_flex: {
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
    },
    copy_btn: {
        color: theme.palette.primary.main,
    },
    label_container: {
        maxWidth: '250px',
        width: '100%',
        marginRight: '8px',
    }
}));

export {useStyles}